import {Backbone} from 'Vertebrae';
import {Vertical} from '../model/vertical';

export const Verticals = Backbone.Collection.extend({
    _name: 'Verticals',
    model: Vertical,
});
